import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_CONFIG, ApiConfig, DEFAULT_API_CONFIG } from '../base/api-config';

export interface InAppNotificationDto {
  id: string;
  marinaId: string;
  audience: string;
  customerId?: string | null;
  type: string;
  title: string;
  message: string;
  entityType?: string | null;
  entityId?: string | null;
  deepLink: string;
  createdAt: string;
  isRead: boolean;
}

export interface InAppNotificationFeedDto {
  items: InAppNotificationDto[];
  unreadCount: number;
}

export interface InAppNotificationUnreadCountDto {
  unreadCount: number;
}

export type NotificationAudienceMode = 'staff' | 'customer';

@Injectable({
  providedIn: 'root',
})
export class NotificationApiService {
  private readonly http = inject(HttpClient);
  private readonly config: ApiConfig = inject(API_CONFIG, { optional: true }) ?? DEFAULT_API_CONFIG;

  private get baseUrl(): string {
    return `${this.config.baseUrl.replace(/\/$/, '')}/notifications`;
  }

  getFeed(mode: NotificationAudienceMode, limit = 20): Observable<InAppNotificationFeedDto> {
    return this.http.get<InAppNotificationFeedDto>(`${this.baseUrl}/${mode}`, {
      params: { limit: String(limit) },
      withCredentials: true,
    });
  }

  getUnreadCount(mode: NotificationAudienceMode): Observable<InAppNotificationUnreadCountDto> {
    return this.http.get<InAppNotificationUnreadCountDto>(`${this.baseUrl}/${mode}/unread-count`, {
      withCredentials: true,
    });
  }

  markRead(mode: NotificationAudienceMode, id: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${mode}/${id}/read`, null, {
      withCredentials: true,
    });
  }

  markAllRead(mode: NotificationAudienceMode): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${mode}/read-all`, null, {
      withCredentials: true,
    });
  }
}
